import React from "react";
import { EnvironmentsEnum } from "@elrondnetwork/dapp-core/types";
import {
	TransactionsToastList,
	SignTransactionsModals,
	NotificationModal,
} from "@elrondnetwork/dapp-core/UI";
import { DappProvider } from "@elrondnetwork/dapp-core/wrappers";

import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
import { Layout } from "components";
import { apiTimeout } from "config";
import { PageNotFound, Unlock } from "pages";
import { routeNames } from "routes";
import { routes } from "routes";

export const App = () => {
	return (
		<Router>
			<DappProvider
				environment={EnvironmentsEnum.mainnet}
				customNetworkConfig={{
					name: "customConfig",
					apiTimeout,
				}}
			>
				<Layout>
					<TransactionsToastList />
					<NotificationModal />
					<SignTransactionsModals className="custom-class-for-modals" />
					<Routes>
						<Route path={routeNames.unlock} element={<Unlock />} />
						{routes.map((route, index) => (
							<Route
								path={route.path}
								key={"route-key-" + index}
								element={<route.component />}
							/>
						))}
						<Route path="*" element={<PageNotFound />} />
					</Routes>
				</Layout>
			</DappProvider>
		</Router>
	);
};
